import React from "react";
import ReactWOW from 'react-wow'
import cardsImg  from "../../assets/images/cards-small.svg"
import card from "../../assets/images/card.svg"
import cardItems  from "../../assets/images/card-items.svg"
import {getAuthToken} from "../../services/ApiService";
import {Link} from "react-router-dom";
import { CURRENT_YEAR, CURRENT_MONTH_SHORT } from "../../utils/constants.js";
import Slider from "../Slider";


const Banner = (props) => {
  
  return (
    <section className="banner">
      <div className="container">
        <div className="row">
        
          <div className="col-12 col-lg-6 banner-left">
            <ReactWOW animation="fadeInLeft" delay="0.5s" >
              <div className="banner-text">
                <h1><span className="s-text">Maximize </span>your <br/> credit card <span className="s-text">rewards</span>
                </h1>
                <p>luci maximizes your rewards by finding the best credit card, personalized to the way you spend.</p>
              </div>
            </ReactWOW>
            
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center"}}>
            
              {/* card icons */}
              <div className="card-area">
                <figure>
                  <img src={cardsImg} alt=""/>
                </figure>
              </div>
              
              {/* buttons */}
              <div className="btn-area" style={{marginTop: "-15px", marginBottom: "20px"}}>
                <button
                    className="btn luci-btn primary-btn font-weight-bold pt-3 pb-3"
                    type="submit"
                    onClick={() => props.history.push("/find-best-card-for-your-spend")}
                >
                  Find Your Best Card & Earn More!
                </button>
              </div>
            </div> 
          </div>
          
          
          <div className="col-12 col-lg-6 banner-right">
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%"}}>

              {/* graphics 
              <ReactWOW animation="fadeInRight" delay="0.5s">
                <figure className="card-lg">
                  <img src={card} alt=""/>
                </figure>
              </ReactWOW>
              <ReactWOW animation="fadeInUp" delay="0.75s">
                <figure className="card-items">
                  <img src={cardItems} alt=""/>
                </figure>
              </ReactWOW>
                  */}

              {/* tetimonials */}
              <ReactWOW animation="fadeInUp" delay="1s">
                <div style={{}}>
                  <Slider {...props} />
                </div>
              </ReactWOW>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
